var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcApplePayBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "24px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icApplePayBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHP-store-check-your-cart",
    transform: "translate(-662.000000, -753.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(420.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy",
    transform: "translate(130.000000, 564.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(111.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icApplePayBlack",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5143325,24 C2.94909545,23.979422 0,16.6879771 0,12.9746145 C0,6.90884784 4.54187461,5.58088912 6.2922801,5.58088912 C7.08111354,5.58088912 7.92342483,5.89124616 8.66635995,6.16588471 C9.18588584,6.35746138 9.72319089,6.55522552 10.0220212,6.55522552 C10.200889,6.55522552 10.6223955,6.38699241 10.9945415,6.23938415 C11.788194,5.92283967 12.7757798,5.52942076 13.925811,5.52942076 C13.9278696,5.52942076 13.9306301,5.52942076 13.9326419,5.52942076 C14.7913755,5.52942076 17.3950873,5.71823184 18.9604492,8.07340155 L19.327121,8.62544425 L18.7994074,9.02439436 C18.045524,9.59429631 16.6699782,10.6338822 16.6699782,12.6931323 C16.6699782,15.132067 18.2278072,16.0700286 18.9762165,16.5211502 C19.3065814,16.7202737 19.6485496,16.9255847 19.6485496,17.3746438 C19.6485496,17.6678447 17.3128353,23.9636253 13.9209919,23.9636253 C13.0910324,23.9636253 12.5043668,23.7136897 11.9868996,23.4932851 C11.4633032,23.2701149 11.0116188,23.077882 10.2652682,23.077882 C9.88694635,23.077882 9.40854648,23.2570837 8.90207424,23.447301 C8.20995009,23.706096 7.42654398,24 6.53763256,24 L6.5143325,24 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2851372,0 C14.3734716,3.1910384 12.0956332,5.40483418 9.82046163,5.26599147 C9.44555521,2.71943258 12.0953525,0 14.2851372,0 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApplePayBlack);
export default __webpack_public_path__ + "static/media/icApplePayBlack.0554685c2cc1bd0ed1c79c87acf1687d.svg";
export { ForwardRef as ReactComponent };